import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import { gr } from "../tokens";

// Initials from a display name; names the API sends as "undefined" are ignored.
export const grInitials = (name = "") =>
  String(name)
    .split(/\s+/)
    .filter(
      (part) =>
        part &&
        part.toLowerCase() !== "undefined" &&
        part.toLowerCase() !== "null"
    )
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

const sizes = { sm: 32, md: 40, lg: 56, xl: 120 };

// Person photo. When the photo is missing or fails to load it shows the initials
// (or a person icon) on brand-soft instead of the browser's broken-image alt text.
export default function GrAvatar({ src, name, size = "md", sx, ...rest }) {
  const px = typeof size === "number" ? size : sizes[size];
  const hasSrc = src && !/\/(undefined|null)?$/.test(src);
  return (
    <Avatar
      src={hasSrc ? src : undefined}
      alt={name || ""}
      sx={{
        width: px,
        height: px,
        fontFamily: gr.font.family,
        fontSize: `calc(${px}px * 0.4)`,
        fontWeight: gr.font.weight.semibold,
        bgcolor: gr.color.brandSoft,
        color: gr.color.brandDark,
        ...sx,
      }}
      {...rest}
    >
      {grInitials(name) || undefined}
    </Avatar>
  );
}

GrAvatar.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["sm", "md", "lg", "xl"]),
    PropTypes.number,
  ]),
  sx: PropTypes.object,
};
